import { Store } from 'src/store/index';

const getDesignId = (store: Store) => store.design.designId;
export default getDesignId;
